import React from 'react';

export default function AboutHero() {
  return (
    <section className='writing-hero-background page-hero page-hero--about'>
      <div className='hero-content row container-large'>
        <div className='hero-text page-hero__text'>
          <p className='page-hero__eyebrow'>Author</p>
          <h1>About</h1>
        </div>
        <div className='hero-img page-hero__media'>
          <img
            src={process.env.PUBLIC_URL + '/images/sky-portrait-2.webp'}
            alt='Portrait of J. Schuyler Sprowles'
          />
        </div>
      </div>
    </section>
  );
}
